export default {
    path: '/protocol',
    meta: {
        title: '',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/protocol`),
}


// WEBPACK FOOTER //
// ./src/views/Protocol/router.js